export default "Aides aux sites industriels 2026 — CEE IND, Fonds chaleur, Fonds décarbonation | Solution Éco France";
